export default "__VITE_ASSET__CZR_l1BH__"